<template>
    <div class="details-panel details-panel__white my-0 py-0" v-if="isNotEmpty">

        <div class="details-panel__body ">
            <div class="row py-2">
                <div class="col-8 col-md-8">
                    <div class="row">
                        <div class="col-12 col-md">
                            <div class="custom-control custom-checkbox b-custom-control-lg">
                                <input
                                    type="checkbox"
                                    :id="'leaseProlong_' + product"
                                    v-model="status"
                                    value = "1"
                                    @click="addToCart(product)"
                                    class="custom-control-input"
                                    :name="'leaseProlongChecked[' + product + ']'"
                                >
                                <label :for="'leaseProlong_' + product" class="custom-control-label d-flex flex-wrap">
                                    {{ products[product].name }} {{ getTranslation('cart-vue', 'lease_prolongation') }}
                                </label>
                            </div>
                        </div>
                        <div class="col-12 col-md">
                            <template v-if="isTruss4Product(product)">
                                {{ getPluralTranslation('lease-prolong-vue', 'licences_no_plural', $store.state.cart.leaseProlong[product].info.length ) }}
                                ({{ products[product].grace_lease_agreement.end_date }})

                            </template>
                            <template v-if="!isTruss4Product(product)">
                                <a href="javascript:;" v-b-toggle="'leaseProlongCollapse_' + product" class="btn-link--trigger d-inline-flex align-items-center mb-0">
                                    {{ getTranslation('single-upgrade-vue', 'selected_programs') }}
                                    <span class="collapse-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-caret-down fa-w-10 fa-2x"><path fill="currentColor" d="M287.968 160H32.038c-28.425 0-42.767 34.488-22.627 54.627l127.962 128c12.496 12.496 32.758 12.497 45.255 0l127.968-128C330.695 194.528 316.45 160 287.968 160zM160 320L32 192h256L160 320z"></path>
                                        </svg>
                                    </span>
                                </a>
                            </template>

                        </div>
                    </div>
                </div>
                <div class="col-4 col-md-4">
                    <div class="row">
                        <div class="col-12 col-md text-right order-md-last">
                            {{ priceFormat(leaseProlongPrice, true) }}
                        </div>
                        <div class="col-12 col-md text-right text-md-left">
                            <template v-if="isTruss4Product(product)">
                                {{ translateLeaseEnd(products[product].grace_lease_agreement.months) }}
                            </template>
                            <template v-if="!isTruss4Product(product)">
                                {{ getTranslation('front', 'subscription_renewal_box_period_one_year') }}
                            </template>

                        </div>

                    </div>
                </div>

            </div>


            <div v-if="typeof (programData) != 'undefined'">

                <b-collapse :id="'leaseProlongCollapse_' + product" class="row ">
                    <div v-for="key in existingKeys" class="col-12 view-extras pl-5 mt-3" v-if="hasLicences(key.key_id)">
                        <div class="custom-control custom-checkbox">
                            <input
                                type="checkbox"
                                :id="'toggle_lease_key' + product + '_' + key.key_id"
                                v-model="keyStatus[key.key_id]"
                                @click="toggleKey(key.key_id)"
                                :value = "1"
                                class="custom-control-input"
                            >
                            <label :for="'toggle_lease_key' + product + '_' + key.key_id" class="custom-control-label">
                                #{{ key.key_id }} {{ key.key_name }}
                            </label>
                        </div>

                        <div
                            v-for="(program, index) in programData.info"
                            class="col-12 view-extras"
                            v-if="program.key == key.key_id"
                        >
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    :id="'lease_prolong_' + product + '_' + index"
                                    @click="toggleLeaseProlongProgram(product, index)"
                                    v-model="programData.info[index].selected"
                                    :value = "1"
                                    :name = "'lease_prolong[' + product + '][' + program.user_licence_id + ']'"
                                    class="custom-control-input">
                                <label :for="'lease_prolong_' + product + '_' + index" class="custom-control-label">
                                    {{ program.name }} <span v-if="program.quantity > 1">( {{ program.quantity }} )</span>
                                    {{ program.version }}
                                    <template v-if="program.discount > 0">
                                        ({{ program.discount }}% {{ getTranslation('lease-prolong-vue', 'discount')}})
                                    </template>
                                    <b>{{ priceFormat(getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, program.quantity, false, program.discount)) }}</b>
                                </label>
                            </div>

                        </div>

                    </div>

                </b-collapse>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            resetHardlocksAndCartStep() {
                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
                this.$store.commit('emptyHardlocks');
                this.$store.commit('setMustConfirm', 1);
                this.deleteLeaseProlongData();
            },
            deleteLeaseProlongData() {
                let self = this;
                //delete the options
                _.forOwn(this.products, function(p) {
                    if (!self.isTruss4Product(p.id)) {
                        let payload = {product: p.id};
                        self.$store.commit('deleteLeaseProlongConfig', payload);
                        self.$store.commit('updateLeaseOptions', {
                            id: p.id,
                            data: {},
                        });
                    }
                });

                //delete the days
                _.forOwn(this.$store.state.cart.programs, function(p) {
                    //clear the custom days
                    let payload = {
                        id: p.id,
                        upgrade: false,
                        column: 'days'
                    }
                    self.$store.commit('upgradeCartProgram', payload);

                    //clear the perpetual upgrade
                    payload = {
                        id: p.id,
                        upgrade: false,
                        column: 'perpetual_upgrade'
                    }
                    self.$store.commit('upgradeCartProgram', payload);
                });
            },
            addToCart(product) {
                this.$store.commit('toggleLeaseProlong', product);
                this.resetHardlocksAndCartStep();
            },
            toggleLeaseProlongProgram(product, index) {
                //toggle product
                this.$store.commit('toggleLeaseProlongProgram', {
                    product: product,
                    index: index
                });
                this.$store.commit('toggleLeaseProlongPrice', {
                    product: product,
                    price: this.leaseProlongPrice
                });
                this.resetHardlocksAndCartStep();
            },
            hasLicences(key) {
                if (typeof this.leaseProlong[this.product] == 'undefined') {
                    return false;
                }
                let found = this.leaseProlong[this.product].info.find(l => l.key == key);
                return typeof found !== 'undefined';

            },
            toggleKey(key) {
                let self = this;
                this.$store.state.cart.leaseProlong[this.product].info.forEach(function(l, index) {
                    if (l.product == self.product && l.key == key && l.selected == self.keyStatus[key]) {
                        self.toggleLeaseProlongProgram(self.product, index);
                    }
                });
                self.keyStatus[key] = !self.keyStatus[key];
            }
        },
        mounted() {

            let self = this;
            this.programData = this.$store.state.cart.leaseProlong[this.product];

            if (!_.isUndefined(this.programData)) {
                this.programData.info.forEach(function(l, index) {
                    l.price = self.getProgramPrice(l.id, '', l.licence_type, l.product, l.quantity)
                });
            }

            if ( Object.keys(this.existingKeys).length !== 0) {
                this.existingKeys.forEach(function (k) {
                    if (typeof self.programData != 'undefined') {
                        let found = self.programData.info.find(l => l.selected == false);
                        if (typeof found !== 'undefined') {
                            self.keyStatus[k.key_id] = false;
                        } else {
                            self.keyStatus[k.key_id] = true;
                        }
                    }
                });
            }

        },
        computed: {
            sortedPrograms() {
                return _.orderBy(this.programData.info, ['sort_order'], ['desc']);
            },
            leaseProlongPrice() {
                let self = this;
                if (_.isNil(this.programData)) {
                    return 0;
                }
                if (_.isNil(this.programData.info)) {
                    return 0;
                }
                let total = 0;
                if (this.isTruss4Product(this.product)) {
                    let info = this.programData.info[0];
                    return this.getTruss4Price(info.id, '', info.licence_type, info.product, this.programData.info.length, true)
                }
                _.forOwn(this.programData.info, function(pr, key) {
                    if (pr.selected == true && self.programData.status) {
                        total += self.getProgramPrice(pr.id, '', 'cloud_time_quantity', pr.product, pr.quantity, false, pr.discount)
                    }
                });
                return total;
            },
            status: {
                get () {
                    if (typeof (this.$store.state.cart.leaseProlong[this.product]) != 'undefined') {
                        return this.$store.state.cart.leaseProlong[this.product].status || false;
                    }
                    return false;
                },
                set (val) {
                    //
                }
            },
            isNotEmpty() {
                if (!this.isTruss4Product(this.product)) {
                    return false;
                }
                return !_.isUndefined(this.$store.state.cart.leaseProlong[this.product])
            }
        },
        data() {
            return {
                leaseProlong: JSON.parse(window.leaseProlong),
                products: window.jsonProducts,
                existingKeys: JSON.parse(window.existingKeys),
                keyStatus: {},
                programData: {},
            };
        },
        props: {
            product: {
                type: [Number, String],
                required: true
            }
        }
    }
</script>
